import _tmpl from "./image.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Variant = /*#__PURE__*/function (Variant) {
  Variant["Default"] = "default";
  Variant["Circle"] = "circle";
  Variant["Rounded"] = "rounded";
  return Variant;
}({});
let Padding = /*#__PURE__*/function (Padding) {
  Padding["Default"] = "default";
  Padding["Small"] = "small";
  Padding["Medium"] = "medium";
  Padding["Large"] = "large";
  return Padding;
}({});
let BorderRadius = /*#__PURE__*/function (BorderRadius) {
  BorderRadius["Default"] = "default";
  BorderRadius["XSmall"] = "xsmall";
  BorderRadius["Small"] = "small";
  BorderRadius["Medium"] = "medium";
  return BorderRadius;
}({});
class Image extends LightningElement {
  constructor(...args) {
    super(...args);
    this.variant = Variant.Default;
    this.padding = Padding.Default;
    this.border = false;
    this.shadow = false;
    this.borderRadius = BorderRadius.Default;
    this.imgSrc = "";
    this.alt = "";
    this.elementHeight = "";
    this.elementWidth = "";
    this.loading = false;
    this.loaded = false;
  }
  get classes() {
    return classNames("element", {
      [`skeleton-loading`]: this.loading,
      [`skeleton-loaded`]: this.loaded,
      [`variant-${this.variant}`]: Object.values(Variant).includes(this.variant),
      [`styling-padding-${this.padding}`]: this.padding !== "default" && Object.values(Padding).includes(this.padding),
      [`styling-border`]: this.border === "true",
      [`styling-shadow`]: this.shadow === "true",
      [`styling-border-radius-${this.borderRadius}`]: this.borderRadius !== "default" && Object.values(BorderRadius).includes(this.borderRadius)
    });
  }
  get width() {
    return this.elementWidth;
  }
  set width(value) {
    this.template.host.style.setProperty("--axds-ovr-image-width", value);
    this.elementWidth = value;
  }
  get height() {
    return this.elementHeight;
  }
  set height(value) {
    this.template.host.style.setProperty("--axds-ovr-image-height", value);
    this.elementHeight = value;
  }

  // Loading
  connectedCallback() {
    this.loading = true;
    this.loaded = false;
  }
  handleLoaded() {
    this.loaded = true;
    this.template.querySelector("img").addEventListener("transitionend", () => {
      this.loading = false;
    }, {
      once: true
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Image, {
  publicProps: {
    variant: {
      config: 0
    },
    padding: {
      config: 0
    },
    border: {
      config: 0
    },
    shadow: {
      config: 0
    },
    borderRadius: {
      config: 0
    },
    imgSrc: {
      config: 0
    },
    alt: {
      config: 0
    },
    width: {
      config: 3
    },
    height: {
      config: 3
    }
  },
  fields: ["elementHeight", "elementWidth", "loading", "loaded"]
});
const __lwc_component_class_internal = _registerComponent(Image, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;